import { forwardRef, useState } from "react";
import { Button } from "@mui/material";
import DeleteSweepIcon from "@mui/icons-material/DeleteSweep";
import { ModalDeleteConditionality } from "components/ModalDeleteConditionality";

export const DeleteConditionalityButton = forwardRef(({
  conditionality,
}, ref) => {

  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <>
      <Button
        ref={ref}
        startIcon={<DeleteSweepIcon />}
        onClick={openModal}
        sx={{
          background: "rgba(224, 46, 26, 0.1)",
          height: "54px",
          padding: "15px 16px",
          borderRadius: "8px",
          fontFamily: 'Poppins, sans-serif',
          color: '#E02E1A',
          fontSize: '16px',
          fontWeight: 200,
          textTransform: 'none',
          '&:hover': {
            backgroundColor: "rgba(224, 46, 26, 0.1)",
          },
        }}
      >
        Excluir acompanhamento
      </Button>

      <ModalDeleteConditionality
        isOpen={isModalOpen}
        handleClose={closeModal}
        conditionalityId={conditionality.id}
      />
    </>
  );
});
